import React, { Component } from "react";
import {
  Button,
  message,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
  Upload,
  Modal,
  Spin,
  Tooltip,
  Space,
  Image,
} from "antd";
import { PlusOutlined, UploadOutlined, CloseOutlined } from "@ant-design/icons";
import { StoreContext } from "../store/RootStore";
import { observer } from "mobx-react";
import Password from "antd/es/input/Password";
import withRouter from "../withRouter";
import StaffStore from "../store/StaffStore";
import CompanyAutocomplete from "./CompanyAutocomplete";
import VehicleStore from "../store/VehicleStore";
import moment from "moment";
import CompanyStore from "../store/CompanyStore";
import dayjs from "dayjs";
import DepartmentStore from "../store/DepartmentStore";
import { format, addMinutes } from "date-fns";
import CountryStore from "../store/CountryStore";
import config from "../config";
import conf from "../config";
import addIcon from "../assets/images/NewDesign/plus-lg.svg";

import axios from "axios";
import Cookies from "universal-cookie";
import { decode as base64_decode, encode as base64_encode } from "base-64";
import { hasFeature } from "../utils/componentVisibility";
const features = {
  showEmployeeAwtlFormFields: hasFeature("showEmployeeAwtlFormFields"),
  callJourneyPlannerApi: hasFeature("callJourneyPlannerApi"),
};

const layout = {
  labelCol: { span: 10 },
  wrapperCol: { span: 20 },
};

const startTime = new Date(2000, 0, 1, 0, 0); // 12:00 AM
const endTime = new Date(2000, 0, 1, 23, 45); // 11:45 PM

const timeArray = [];
for (let time = startTime; time <= endTime; time = addMinutes(time, 30)) {
  const formattedTime = format(time, "h:mm aa");
  timeArray.push(formattedTime);
}

const validateMessages = {
  required: "${label} is required!",
  types: {
    email: "${label} is not a valid email!",
    number: "${label} is not a valid number!",
  },
  number: {
    range: "${label} must be between ${min} and ${max}",
  },
};

const { Option } = Select;

class StaffAdd extends Component {
  formRef = React.createRef();

  constructor(prop) {
    super(prop);
    this.state = {
      loading: false,
      employeeType: [],
      department: [],
      showDeptForm: false,
      departmentId: "",
      loadList: 0,
      companyId: "",
      getVehicles: [],
      userId: -1,
      id: -1,
      photo: "",
      loadingSpin: false,
      token: "",
    };
    this.staffStore = new StaffStore(this);
    this.vehicleStore = new VehicleStore(this);
    this.companyStore = new CompanyStore(this);
    this.departmentStore = new DepartmentStore(this);
    this.countryStore = new CountryStore(this);
    this.cookies = new Cookies();
  }

  normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList;
  };

  async componentDidMount() {
    let tokendata = this.cookies.get("data")
      ? JSON.parse(base64_decode(this.cookies.get("data")))
      : "";
    const userToken = tokendata.userToken;

    this.setState({ token: userToken });
    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {
      this.context.viewStateStore.setStaffStates({
        companyId: this.props.getUserData().userCompanyId,
      });

      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });

    }
    await this.departmentStore.getUserDepartmentData();
    await this.countryStore.getCountry();
    const employeeType = await this.staffStore.getEmployeeType();
    await this.setState({ employeeType: employeeType });
    const department = await this.staffStore.getDepartment();
    await this.setState({ department: department });
    if (features.callJourneyPlannerApi) {
      await this.staffStore.getManagersdata(this.props.getUserData().userCompanyId);
    }
    await this.setState({ loadList: 1 });

    const staffId = this.props.staffId;
    if (staffId) {
      this.filldata(staffId);
    }
  }

  async filldata(staffId) {
    await this.setState({ loadingSpin: true });
    const getStaffData = await this.staffStore.getStaffData(staffId);
    const getVehicles = await this.vehicleStore.getVehicles(
      getStaffData.companyId
    );
    await this.setState({ getVehicles: getVehicles });

    await this.setState({
      userId: getStaffData.userId,
      companyId: getStaffData.companyId,
    });
    await this.setState({ id: getStaffData.id });
    const singleData = await this.companyStore.getCompanyDataById(
      getStaffData.companyId
    );
    await this.staffStore.getVehicleNo(getStaffData.companyId);
    await this.departmentStore.getUserDepartmentData();
    this.formRef.current.setFieldsValue({
      name: getStaffData.name,

      departmentId:
        getStaffData.departmentId && Number(getStaffData.departmentId),
      companyId: singleData,
      bloodgroup: getStaffData.bloodGroup,
      alertInterval: getStaffData.alertInterval,
      alertDsateTime: moment(getStaffData.alertDateTime),
      address: getStaffData.address,
      UUID: getStaffData.UUID,
      Tagid: getStaffData.Tagid,
      Nationality: getStaffData.Nationality
        ? Number(getStaffData.Nationality)
        : null,
      Employementstatus: getStaffData.Employementstatus,

      mobilenumber: getStaffData.mobileno,
      licensenumber: getStaffData.licensenumber,
      id: getStaffData.id,

      licenseexpirydate: getStaffData.expireDate
        ? dayjs(getStaffData.expireDate)
        : null,
      employeeId: getStaffData.employeeId,
      emergencyContNumber: getStaffData.e_contactNo,
      emergencyContName: getStaffData.e_contactName,

      SalesPersonType: getStaffData.salesPersonTypeId,
      permitNo: getStaffData.permitNo,
      permitExpiryDate: getStaffData.permitExpiryDate
        ? dayjs(getStaffData.permitExpiryDate)
        : null,
      overtimeCharges: getStaffData.overtimeCharges,
      otherPermit: getStaffData.otherPermit,
      notes: getStaffData.notes,
      userId: getStaffData.userId,

      workingHours: getStaffData.workingHours,
      visaExpiryDate: getStaffData.visaExpiryDate
        ? dayjs(getStaffData.visaExpiryDate)
        : null,
      vehicleId: getStaffData.vehicleId,
      trackingInterval: getStaffData.trackingInterval,
      status: getStaffData.status,
      userName: getStaffData.username,
      password: getStaffData.password,
      trackingTimeFrom: getStaffData.trackingTimeFrom
        ? dayjs(getStaffData.trackingTimeFrom, "hh:mm A")?.format("HH:mm")
        : null,
      trackingTimeTo: getStaffData.trackingTimeTo
        ? dayjs(getStaffData.trackingTimeTo, "hh:mm A")?.format("HH:mm")
        : null,
      countryCode: getStaffData.countryCode,
      emergencyConCountryCode: getStaffData.emergencyConCountryCode,

      journeyManager1: getStaffData.journeyManager1 ? Number(getStaffData.journeyManager1) : null,
      journeyManagerEmailId1: getStaffData.journeyManagerEmailId1,
      journeyManagerContactNo1: getStaffData.journeyManagerContactNo1,

      journeyManager2: getStaffData.journeyManager2 ? Number(getStaffData.journeyManager2) : null,
      journeyManagerEmailId2: getStaffData.journeyManagerEmailId2,
      journeyManagerContactNo2: getStaffData.journeyManagerContactNo2,
      emailId: getStaffData.emailId,
      designation: getStaffData.designation,
      typeOfEmployee: getStaffData.typeOfEmployee,
      journeyDesk: getStaffData.journeyDesk,
      safetyManager: getStaffData.safetyManager,
      safetyManagerEmailId: getStaffData.safetyManagerEmailId,
      safetyManagerContactNo: getStaffData.safetyManagerContactNo,
      projectName: getStaffData.projectName,
      emergencyEmailId: getStaffData.emergencyEmailId,
    });

    this.setState({ photo: getStaffData.photo });
    this.setState({ trackingTimeFrom: getStaffData.trackingTimeFrom });
    this.setState({ trackingTimeTo: getStaffData.trackingTimeTo });
    await this.setState({ loadingSpin: false });
  }

  fillEmployeeType = () => {
    const employeeType = this.state.employeeType;
    if (employeeType) {
      return employeeType.map((value) => {
        return <Select.Option value={value.Id}>{value.type}</Select.Option>;
      });
    }
  };

  onStaffDetailsSubmit = async (fieldsValue) => {
    if (this.state.fileList?.size > conf.photoUploadSize) {
      message.error("File size must be less than or equal to 10MB");
      return;
    }
    let filterType = ["image/jpeg", "image/png", "image/jpg"];
    if (
      this.state.photo?.length > 0 &&
      this.state.fileList?.type !== undefined &&
      !filterType.includes(this.state.fileList?.type)
    ) {
      message.error("Only JPG,JPEG,PNG Files are allowed");
      return;
    }

    this.setState({ loading: true });
    const data = {
      ...fieldsValue,
      companyId: this.state.companyId,
      id: this.state.id,
      userId: this.state.userId,
      visaExpiryDate: fieldsValue?.visaExpiryDate
        ? fieldsValue?.visaExpiryDate?.format("YYYY-MM-DD")
        : null,
      licenseexpirydate: fieldsValue?.licenseexpirydate
        ? fieldsValue?.licenseexpirydate?.format("YYYY-MM-DD")
        : null,
      permitExpiryDate: fieldsValue?.permitExpiryDate
        ? fieldsValue?.permitExpiryDate?.format("YYYY-MM-DD")
        : null,
      photo: this.state.photo,
    };
    const response = await this.staffStore.addData(data);
    await this.props.response(response);

    this.setState({ loading: false });
  };

  onDeptDetailsSubmit = async (fieldValues) => {
    const data = { department: fieldValues };
    await this.departmentStore.getUserDepartmentData();
    const response = await this.departmentStore.addDepartment(data);

    if (response.data.success === "S") {
      await this.formRef.current.setFieldsValue({
        departmentId: Number(response.data.data.departmentId),
      });
      this.setState({ departmentId: Number(response.data.data.departmentId) });
      await this.departmentStore.getUserDepartmentData();
      message.success(response.data.message);
      await this.setState({ showDeptForm: false });
      this.setState({ loadList: 1 });
    } else {
      await message.error(response.data.message);
    }
    await this.departmentStore.getUserDepartmentData();
    this.setState({ loadList: 1 });
  };

  selectDepartment = async (value) => {
    await this.setState({ departmentId: value });
    this.formRef.current.setFieldsValue({ departmentId: value });
  };

  async handleChange(comp) {
    await this.staffStore.getVehicleNo(comp.value);

    if (!this.props.staffId) {
      this.context.viewStateStore.setStaffStates({ companyId: comp.value });
    }
    this.setState({ companyId: comp.value });

    await this.handleSearch();
  }

  async handleSearch() {
    await this.staffStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      searchField: this.state.searchField,
      companyId: this.state.companyId,
      isadmin: this.props.getUserData().isadmin,
    });
    await this.setState({ loadList: 1 });
  }

  timeOptions = () => {
    const timeArray = [];

    let startTime = new Date(2000, 0, 1, 0, 0); // 12:00 AM

    let endTime = new Date(2000, 0, 1, 23, 30);
    for (let time = startTime; time <= endTime; time = addMinutes(time, 30)) {
      const formattedTime = format(time, "HH:mm");
      var ob = {
        formattedTime: formattedTime,
        time: time,
      };
      timeArray.push(ob);
    }
    return timeArray.map((data) => {
      return (
        <Select.Option key={data.formattedTime} value={data.formattedTime}>
          {format(data.time, "h:mm aa")}
        </Select.Option>
      );
    });
  };

  validatePhoneNumber = (value, field1) => {
    const value1 = value.replace(/[^0-9+]*/g, "");
    if (value1.length > 0) {
      this.formRef.current.setFieldsValue({ [field1]: value1 });
    } else {
      this.formRef.current.setFieldsValue({ [field1]: "" });
    }
  };

  validateNumber = (value, field1) => {
    const value1 = value.replace(/[^0-9+]*/g, "");
    if (value1 > 0) {
      this.formRef.current.setFieldsValue({ [field1]: value1 });
    } else {
      this.formRef.current.setFieldsValue({ [field1]: "" });
    }
  };

  validateNumberAndDecimal = (value, field) => {
    const value1 = value.replace(/[^0-9.,]+/g, "");
    if (value1.length > 0) {
      this.formRef.current.setFieldsValue({ [field]: value1 });
    } else {
      this.formRef.current.setFieldsValue({ [field]: "" });
    }
  };

  validateFile = (file) => {
    this.setState({ fileList: file });
    const allowedExtensions = [".jpeg", ".jpg", ".png"];
    const fileName = file.name;
    const fileExtension = fileName.slice(
      ((fileName.lastIndexOf(".") - 1) >>> 0) + 2
    );
    if (!allowedExtensions.includes("." + fileExtension.toLowerCase())) {
      message.error("Only JPEG and PNG files are allowed");
      return false;
    }
    const maxSize = conf.photoUploadSize;
    if (file.size > maxSize) {
      message.error("File size must be less than or equal to 10MB");
      return false;
    }
    return true;
  };

  getUploadData = async (fileUp) => {
    let fileinfo = fileUp.file.response;
    if (fileinfo?.success === "S") {
      await this.setState({ photo: fileinfo.data });
    }
    fileUp.fileList[0].url = config.fleetURL + fileinfo?.folderName;
    this.staffStore.setPhotoFromDb(fileUp.fileList);
    this.setState({ update: 1 });
  };

  uploadFunction = async ({ file, onSuccess, onError, onProgress }) => {
    try {
      const formData = new FormData();
      formData.append("photo", file);
      formData.append("fileType", "salespersonphoto");
      formData.append("fieldName", "photo");

      const response = await axios.post(
        // config.baseURL + this.companyStore.fileUploadUrl,
        config.NodeUrl + "/employee/fileUpload",
        formData,
        {
          headers: {
            token: this.state.token,
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (event) => {
            const percent = Math.round((event.loaded * 100) / event.total);
            onProgress({ percent });
          },
        }
      );

      onSuccess(response.data);
    } catch (error) {
      onError(error);
    }
  };

  closeModal = () => {
    this.props.closeModal();
  };

  render() {
    return (
      <div style={{ padding: 0, height: "100%" }}>
        <div style={{ paddingBottom: "10px", height: "100%" }}>
          <Spin
            wrapperClassName="spinClass"
            spinning={this.state.loadingSpin}
            fullscreen
          >
            <Form
              ref={this.formRef}
              name="nest-messages"
              layout="vertical"
              onFinish={this.onStaffDetailsSubmit}
              className="formClass"
            >
              <Row className="overflowFormInputs">
                <Col span={12} className="formColumnClass">
                  {(this.props.getUserData().isadmin === -1 ||
                    this.props.getUserData().isadmin === 3) && (
                      <Form.Item
                        name="companyId"
                        className="uploadCompany"
                        required={false}
                        label={
                          <span>
                            {this.context.translate(
                              "_FLEET_DRIVER_DRIVERDETAIL_COMPANY_"
                            )}{" "}
                            <span style={{ color: "red" }}>*</span>
                          </span>
                        }
                        rules={[
                          {
                            required: true,
                            message: `${this.context.translate(
                              "_ACCOUNT_"
                            )} ${this.context.translate("_IS_REQUIRED_")}`,
                          },
                        ]}
                      >
                        <CompanyAutocomplete
                          onChange={(value) => this.handleChange(value)}
                          style={{ width: "100%" }}
                          companyId={this.state.companyId}
                        />
                      </Form.Item>
                    )}

                  <Form.Item
                    name="SalesPersonType"
                    className="uploadCompany"
                    required={false}
                    label={
                      <span>{this.context.translate("_EMPLOYEE_TYPE_")} </span>
                    }
                  >
                    <Select
                      placeholder={this.context.translate(
                        "_SELECT_EMPLOYEE_TYPE"
                      )}
                    >
                      {this.fillEmployeeType()}
                    </Select>
                  </Form.Item>

                  <Form.Item label={this.context.translate("_DEPARTMENT_")}>
                    <Space.Compact
                      style={{
                        width: "100%",
                        gap: "10px",
                      }}
                    >
                      <Form.Item name="departmentId" noStyle>
                        <Select
                          className="selectDepartment"
                          key={this.state.departmentId}
                          value={this.state.departmentId}
                          placeholder={this.context.translate(
                            "_SELECT_DEPARTMENT_"
                          )}
                          onSelect={this.selectDepartment}
                          showSearch
                          filterOption={(inputValue, option) => {
                            if (option.children) {
                              return (
                                option.children
                                  .toLowerCase()
                                  .indexOf(inputValue.toLowerCase()) >= 0
                              );
                            }
                          }}
                        >
                          {this.departmentStore?.departments?.map((val) => {
                            return (
                              <Option
                                key={val.departmentId}
                                value={val.departmentId}
                              >
                                {val.departmentName}
                              </Option>
                            );
                          })}
                        </Select>
                      </Form.Item>
                      <Form.Item noStyle>
                        <Button
                          style={{
                            width: "40px",
                            height: "40px",
                            borderRadius: "35px",
                            backgroundColor: "#2196F3",
                            padding: "0px 13px",
                          }}
                          onClick={() => {
                            this.setState({ showDeptForm: true });
                          }}
                        >
                          <Image
                            style={{ width: "13px", height: "13px" }}
                            src={addIcon}
                          ></Image>
                        </Button>
                      </Form.Item>
                    </Space.Compact>
                  </Form.Item>

                  <Form.Item
                    name="name"
                    className="uploadCompany"
                    required={false}
                    label={
                      <span>
                        {this.context.translate("_FLEET_DASHBORD_NEWPOI_NAME_")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    rules={[
                      {
                        required: true,
                        message: `${this.context.translate(
                          "_FLEET_DASHBORD_NEWPOI_NAME_"
                        )} ${this.context.translate("_IS_REQUIRED_")}`,
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    name="userName"
                    className="uploadCompany"
                    required={false}
                    label={
                      <span>
                        {this.context.translate(
                          "_FLEET_USER_USERDETAIL_USERNAME_"
                        )}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    rules={[
                      {
                        required: true,
                        message: `${this.context.translate(
                          "_FLEET_USER_USERDETAIL_USERNAME_"
                        )} ${this.context.translate("_IS_REQUIRED_")}`,
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                  {/* <Form.Item
                    name="password"
                    className="uploadCompany"
                    required={false}
                    
                    label={
                      <span>
                        {this.context.translate(
                          "_FLEET_LOGIN_PASSWORDLBL_"
                        )}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    rules={[{ required: true }]}
                  >
                    <Input.Password 
                    id="form-password"
                 //   style = {{height: "40px"}}
                    />
                  </Form.Item> */}

                  <Form.Item
                    // label={this.context.translate(
                    //   "_FLEET_USER_USERDETAIL_PASSWORD_"
                    // )}
                    className="uploadCompany"
                    required={false}
                    label={
                      <span>
                        {this.context.translate(
                          "_FLEET_USER_USERDETAIL_PASSWORD_"
                        )}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    name="password"
                    rules={[
                      {
                        required: true,
                        message: `${this.context.translate(
                          "_FLEET_USER_USERDETAIL_PASSWORD_"
                        )} ${this.context.translate("_IS_REQUIRED_")}`,
                      },
                    ]}
                  >
                    <Input.Password
                      id="master-form-password"
                    // style={{ height: "35px" }}
                    />
                  </Form.Item>

                  <Form.Item
                    name="employeeId"
                    className="uploadCompany"
                    required={false}
                    label={
                      <span>{this.context.translate("_EMPLOYEE_ID_")} </span>
                    }
                    rules={[{ type: Password }]}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    label={
                      <span>
                        {this.context.translate("_MOBILE_NUMBER_")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                  >
                    <Space.Compact style={{ width: "100%" }}>
                      <Form.Item
                        name="countryCode"
                        noStyle
                        initialValue={config.countryCode}
                      >
                        <Select
                          style={{ width: "55%", borderRadius: "5px" }}
                          showSearch
                          filterOption={(inputValue, option) => {
                            if (option.children) {
                              return (
                                option.children
                                  .toLowerCase()
                                  .indexOf(inputValue.toLowerCase()) >= 0
                              );
                            }
                          }}
                        >
                          {this.countryStore?.country?.map((country) => {
                            return (
                              <Option
                                value={parseInt(country.countryId)}
                                key={country.countryId}
                              >
                                {country.countryCode}
                              </Option>
                            );
                          })}
                        </Select>
                      </Form.Item>
                      <Form.Item
                        name="mobilenumber"
                        noStyle
                        rules={[
                          {
                            pattern: /^\d{8,10}$/,
                            // message: "Enter a 7 or 10 digit number",
                            message: this.context.translate(
                              "_Enter_7_or_10_Digit_Number_"
                            ),
                            required: true,
                          },
                        ]}
                      >
                        <Input
                          style={{ width: "100%" }}
                          onChange={(e) =>
                            this.validatePhoneNumber(e.target.value)
                          }
                        />
                      </Form.Item>
                    </Space.Compact>
                  </Form.Item>

                  {
                    features.showEmployeeAwtlFormFields && (
                      <Form.Item name="emailId" className="uploadCompany" required={false} label={<span>Employee Email ID</span>} rules={[{ type: 'email' }]}>
                        <Input />
                      </Form.Item>
                    )
                  }


                  <Form.Item
                    name="Employementstatus"
                    className="uploadCompany"
                    required={false}
                    label={
                      <span>
                        {this.context.translate("_EMPLOYMENT_STATUS_")}{" "}
                      </span>
                    }
                  >
                    <Select>
                      <Select.Option value="Permanent">
                        {this.context.translate("_PERMANENT_")}
                      </Select.Option>
                      <Select.Option value="Temporary">
                        {this.context.translate("_TEMPORARY_")}
                      </Select.Option>
                    </Select>
                  </Form.Item>

                  <Row>
                    <Col span={11}>
                      <Form.Item
                        name="vehicleId"
                        required={false}
                        // className="uploadCompany"
                        label={
                          <span>
                            {this.context.translate("_ASSET_NUMBER_")}{" "}
                          </span>
                        }
                      >
                        <Select
                          placeholder={this.context.translate(
                            "_FLEET_GROUP_GROUPDETAIL_SELECTVEHICLE_"
                          )}
                          showSearch
                          fieldNames={{
                            value: "vehicleId",
                            label: "vehicleNo",
                          }}
                          optionFilterProp="children"
                          options={this.staffStore?.vehicleList}
                        ></Select>
                      </Form.Item>
                    </Col>
                    <Col span={2} />
                    <Col span={11}>
                      <Form.Item
                        name="visaExpiryDate"
                        //   className="uploadCompany"
                        required={false}
                        label={
                          <span>
                            {this.context.translate("_VISA_EXPIRY_DATE_")}{" "}
                          </span>
                        }
                        rules={[{ type: Date }]}
                      >
                        <DatePicker
                          format={"YYYY-MM-DD"}
                          style={{ width: "100%", height: "40px" }}
                          disabledDate={(current) =>
                            current && current < dayjs().startOf("day")
                          }
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Form.Item
                    name="Nationality"
                    className="uploadCompany"
                    required={false}
                    label={
                      <span>{this.context.translate("_NATIONALITY_")} </span>
                    }
                  >
                    <Select
                      showSearch
                      placeholder={this.context.translate("_SELECT_COUNTRY_")}
                      filterOption={(inputValue, option) => {
                        return (
                          option.children
                            .toLowerCase()
                            .indexOf(inputValue.toLowerCase()) >= 0
                        );
                      }}
                    >
                      {this.countryStore?.country.map((country) => {
                        return (
                          <Option value={parseInt(country.countryId)}>
                            {country.country}
                          </Option>
                        );
                      })}
                    </Select>
                  </Form.Item>

                  <Form.Item
                    name="address"
                    className="uploadCompany"
                    required={false}
                    label={
                      <span>
                        {this.context.translate(
                          "_FLEET_DASHBORD_NEWPOI_ADDRESS_"
                        )}{" "}
                      </span>
                    }
                    rules={[{}]}
                  >
                    <Input />
                  </Form.Item>




                  {features.showEmployeeAwtlFormFields && (
                    <>
                      <Form.Item name="designation" className="uploadCompany" required={false} label={<span>Designation</span>}>
                        <Input />
                      </Form.Item>

                      <Form.Item name="projectName" className="uploadCompany" required={false} label={<span>Project Name</span>}>
                        <Input />
                      </Form.Item>

                      <Form.Item name="typeOfEmployee" className="uploadCompany" required={false} label={<span>Type of employee</span>}>
                        <Input />
                      </Form.Item>

                      <Form.Item name="journeyDesk" className="uploadCompany" required={false} label={<span>Journey Desk</span>}>
                        <Input />
                      </Form.Item>

                      <Form.Item name="otherPermit" className="uploadCompany" required={false} label={<span>Other permit</span>}>
                        <Input />
                      </Form.Item>

                      <Form.Item name="permitNo" className="uploadCompany" required={false} label={<span>Permit No</span>}>
                        <Input />
                      </Form.Item>
                    </>
                  )}
                  <Form.Item
                    name="workingHours"
                    className="uploadCompany"
                    required={false}
                    label={
                      <span>{this.context.translate("_WORKING_HOUR_")} </span>
                    }
                  >
                    <Input
                      onChange={(e) => {
                        this.validateNumberAndDecimal(
                          e.target.value,
                          "workingHours"
                        );
                      }}
                    />
                  </Form.Item>

                  <Form.Item
                    name="overtimeCharges"
                    className="uploadCompany"
                    required={false}
                    label={
                      <span>
                        {this.context.translate("_OVERTIME_CHARGE_")}{" "}
                      </span>
                    }
                    rules={[{ type: Number }]}
                  >
                    <Input
                      onChange={(e) => {
                        this.validateNumberAndDecimal(
                          e.target.value,
                          "overtimeCharges"
                        );
                      }}
                    />
                  </Form.Item>



                </Col>

                <Col span={12} className="formColumnClass">
                  <Form.Item
                    name="alertInterval"
                    className="uploadCompany"
                    required={false}
                    label={
                      <span>
                        {this.context.translate(
                          "_FLEET_RULEADMIN_RULEDETAIL_MININTERVAL_"
                        )}{" "}
                      </span>
                    }
                  >
                    <Select placeholder={this.context.translate("_MINUTES_")}>
                      <Select.Option value="30">30 </Select.Option>
                      <Select.Option value="60">60</Select.Option>
                      <Select.Option value="90">90</Select.Option>
                      <Select.Option value="120">120</Select.Option>
                      <Select.Option value="180">180</Select.Option>
                    </Select>
                  </Form.Item>

                  <Form.Item
                    name="trackingInterval"
                    className="uploadCompany"
                    required={false}
                    label={
                      <span>
                        {this.context.translate("_TRACKING_INTERVAL_MIN_")}{" "}
                      </span>
                    }
                    rules={[{ type: Number }]}
                  >
                    <Input
                      onChange={(e) => {
                        this.validateNumber(e.target.value, "trackingInterval");
                      }}
                    />
                  </Form.Item>

                  <Form.Item
                    name="trackingTimeFrom"
                    className="uploadCompany"
                    required={false}
                    label={
                      <span>
                        {this.context.translate("_TRACKING_TIME_FROM_")}{" "}
                      </span>
                    }
                  >
                    <Select
                      onSelect={(val) =>
                        this.setState({ trackingTimeFrom: val })
                      }
                      allowClear={true}
                    >
                      {this.timeOptions()}
                    </Select>
                  </Form.Item>

                  <Form.Item
                    name="trackingTimeTo"
                    className="uploadCompany"
                    required={false}
                    label={
                      <span>
                        {this.context.translate("_TRACKING_TIME_TO_")}{" "}
                      </span>
                    }
                  >
                    <Select
                      onSelect={(val) => this.setState({ trackingTimeTo: val })}
                      allowClear={true}
                    >
                      {this.timeOptions()}
                    </Select>
                  </Form.Item>

                  <Form.Item
                    name="licensenumber"
                    className="uploadCompany"
                    required={false}
                    label={
                      <span>
                        {this.context.translate(
                          "_FLEET_DRIVER_DRIVERLIST_LICENCE_"
                        )}{" "}
                      </span>
                    }
                    rules={[{ type: Number }]}
                  >
                    <Input />
                  </Form.Item>

                  <Form.Item
                    name="licenseexpirydate"
                    className="uploadCompany"
                    required={false}
                    label={
                      <span>
                        {this.context.translate(
                          "_FLEET_DRIVER_DRIVERDETAIL_LICENSEEXPIRY_"
                        )}{" "}
                      </span>
                    }
                    rules={[{ type: Date }]}
                  >
                    <DatePicker
                      style={{ width: "100%", height: "40px" }}
                      disabledDate={(current) =>
                        current && current < dayjs().startOf("day")
                      }
                    />
                  </Form.Item>

                  <Form.Item
                    name="permitExpiryDate"
                    className="uploadCompany"
                    required={false}
                    label={
                      <span>
                        {this.context.translate("_PERMIT_EXPIRY_DATE_")}{" "}
                      </span>
                    }
                    rules={[{ type: Date }]}
                  >
                    <DatePicker
                      format={"YYYY-MM-DD"}
                      style={{ width: "100%", height: "40px" }}
                      disabledDate={(current) =>
                        current && current < dayjs().startOf("day")
                      }
                    />
                  </Form.Item>

                  <Form.Item
                    name="bloodgroup"
                    className="uploadCompany"
                    required={false}
                    label={
                      <span>
                        {this.context.translate(
                          "_FLEET_DRIVER_DRIVERDETAIL_BLOODGROUP_"
                        )}{" "}
                      </span>
                    }
                    rules={[{}]}
                  >
                    <Input />
                  </Form.Item>

                  <Form.Item
                    name="emergencyContName"
                    className="uploadCompany"
                    required={false}
                    label={
                      <span>
                        {this.context.translate(
                          "_FLEET_DRIVER_DRIVERDETAIL_EMERGENCYNAME_"
                        )}{" "}
                      </span>
                    }
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    label={this.context.translate(
                      "_FLEET_DRIVER_DRIVERDETAIL_EMERGENCYNUMBER_"
                    )}
                  >
                    <Space.Compact style={{ width: "100%" }}>
                      <Form.Item
                        name="emergencyConCountryCode"
                        noStyle
                        initialValue={config.countryCode}
                      >
                        <Select
                          style={{ width: "55%", borderRadius: "5px" }}
                          showSearch
                          filterOption={(inputValue, option) => {
                            if (option.children) {
                              return (
                                option.children
                                  .toLowerCase()
                                  .indexOf(inputValue.toLowerCase()) >= 0
                              );
                            }
                          }}
                        >
                          {this.countryStore?.country?.map((country) => {
                            return (
                              <Option
                                value={parseInt(country.countryId)}
                                key={country.countryId}
                              >
                                {country.countryCode}
                              </Option>
                            );
                          })}
                        </Select>
                      </Form.Item>
                      <Form.Item
                        name="emergencyContNumber"
                        noStyle
                        rules={[
                          {
                            pattern: /^\d{8,10}$/,
                            // message: "Enter a 7 or 10 digit number",
                            message: this.context.translate(
                              "_Enter_7_or_10_Digit_Number_"
                            ),
                          },
                        ]}
                      >
                        <Input
                          style={{ width: "100%" }}
                          onChange={(e) =>
                            this.validatePhoneNumber(e.target.value)
                          }
                        />
                      </Form.Item>
                    </Space.Compact>
                  </Form.Item>

                  {features.showEmployeeAwtlFormFields && (<> <Form.Item name="emergencyEmailId" className="uploadCompany" required={false} label={<span>Emergency Email ID</span>} rules={[{ type: 'email' }]}>
                    <Input />
                  </Form.Item>

                    <Form.Item
                      name="journeyManager1"
                      className="uploadCompany"
                      label="Journey Manager 1"
                    >
                      <Select placeholder="Select Journey Manager 1">
                        {this.staffStore?.journeymanagerslist?.map((item) => (
                          <Select.Option
                            key={item.id}
                            value={Number(item.id)}
                          >
                            {item.name}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>

                    <Form.Item name="journeyManagerContactNo1" className="uploadCompany" required={false} label={<span>Journey Manager 1 Contact Number</span>}>
                      <Input />
                    </Form.Item>

                    <Form.Item name="journeyManagerEmailId1" className="uploadCompany" required={false} label={<span>Journey Manager 1 Email Id</span>}>
                      <Input />
                    </Form.Item>
                    <Form.Item
                      name="journeyManager2"
                      className="uploadCompany"
                      label="Journey Manager 2"
                    >
                      <Select placeholder="Select Journey Manager 2">
                        {this.staffStore?.journeymanagerslist?.map((item) => (
                          <Select.Option
                            key={item.id}
                            value={item.id}
                          >
                            {item.name}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>

                    <Form.Item name="journeyManagerContactNo2" className="uploadCompany" required={false} label={<span>Journey Manager 2 Contact Number</span>}>
                      <Input />
                    </Form.Item>

                    <Form.Item name="journeyManagerEmailId2" className="uploadCompany" required={false} label={<span>Journey Manager 2 Email Id</span>} rules={[{ type: 'email' }]}>
                      <Input />
                    </Form.Item>

                    <Form.Item
                      name="safetyManager"
                      className="uploadCompany"
                      label="Safety Manager "
                    >
                      <Select placeholder="Select Safety Manager">
                        {this.staffStore?.safetymanagerlist?.map((item) => (
                          <Select.Option
                            key={item.id}
                            value={item.id}
                          >
                            {item.name}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>

                    <Form.Item name="safetyManagerEmailId" className="uploadCompany" required={false} label={<span>Safety Manager Email ID</span>} rules={[{ type: 'email' }]}>
                      <Input />
                    </Form.Item>

                    <Form.Item name="safetyManagerContactNo" className="uploadCompany" required={false} label={<span>Safety Contact Number</span>}>
                      <Input />
                    </Form.Item>
                  </>)}
                  <Form.Item
                    name="notes"
                    className="uploadCompany"
                    required={false}
                    label={
                      <span>
                        {this.context.translate(
                          "_FLEET_DRIVER_DRIVERDETAIL_NOTES_"
                        )}{" "}
                      </span>
                    }
                    rules={[{}]}
                  >
                    <Input />
                  </Form.Item>


                  <Form.Item name="photo" className="formCheckboxCss" label=" ">
                    <Upload
                      name="photo"
                      // action={config.baseURL + this.staffStore.fileUploadUrl}
                      listType="picture"
                      // data={{
                      //   fileType: "salespersonphoto",
                      //   fieldName: "photo",
                      // }}
                      onChange={this.getUploadData}
                      customRequest={(options) => this.uploadFunction(options)}
                      onRemove={async () => {
                        await this.staffStore.setPhotoFromDb([]);
                        await this.setState({ photo: "", fileList: [] });
                      }}
                      maxCount={1}
                      accept=".jpg,.jpeg,.png"
                      beforeUpload={(file) => this.validateFile(file)}
                      {...this.staffStore.photoFromDb}
                    >
                      <Button className="imgupload" icon={<UploadOutlined />}>
                        {this.context.translate(
                          "_FLEET_DRIVER_DRIVERDETAIL_UPLOAD_"
                        )}
                      </Button>
                    </Upload>
                  </Form.Item>
                </Col>
              </Row>
              <div className="formFooter">
                <Button
                  className="formsCancelButton"
                  onClick={() => this.closeModal()}
                >
                  {this.context.translate(
                    "_FLEET_DASHBORD_ROUTEADD_CANCELBTN_"
                  )}
                </Button>
                <Button
                  htmlType="submit"
                  className="formsSaveButton"
                // onClick={() => this.onExcelSubmit()}
                >
                  {this.context.translate("_FLEET_DASHBORD_NEWPOI_SAVEBTN_")}
                </Button>
              </div>
            </Form>
          </Spin>
        </div>

        <Modal
          maskClosable={false}
          title={
            <div className="deleteModalTitle">
              <span> {this.context.translate("_ADD_DEPARTMENT_")}</span>
              <CloseOutlined
                style={{ cursor: "pointer", color: "white" }}
                onClick={() => this.setState({ showDeptForm: false })}
              />
            </div>
          }
          className="addDeptModal"
          description="Add Department"
          centered={false}
          open={this.state.showDeptForm}
          footer={null}
          width={400}
          closable={false}
          style={{ top: 250, insetInlineEnd: 150, position: "absolute" }}
        >
          <Form
            name="nest-messages"
            layout="vertical"
            onFinish={this.onDeptDetailsSubmit}
            style={{ padding: "0px 10px" }}
          >
            <Row>
              <Col span={12}></Col>
              <Col
                span={12}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "end",
                }}
              ></Col>
            </Row>
            <Form.Item
              name="dptname"
              label={this.context.translate("_NAME_")}
              rules={[
                {
                  required: true,
                  message: `${this.context.translate(
                    "_NAME_"
                  )} ${this.context.translate("_IS_REQUIRED_")}`,
                },
              ]}
            >
              <Input />
            </Form.Item>

            <div className="addDeptModalButtons">
              <Button
                className="addDeptModalCancelButton"
                onClick={() => this.setState({ showDeptForm: false })}
              >
                {this.context.translate("_FLEET_DASHBORD_ROUTEADD_CANCELBTN_")}
              </Button>
              <Button
                className="addDeptModalOkButton"
                htmlType="submit"
                loading={this.state.loading}
              >
                {this.context.translate("_FLEET_DASHBORD_NEWPOI_SAVEBTN_")}
              </Button>
            </div>
          </Form>
        </Modal>
      </div>
    );
  }
}

StaffAdd.contextType = StoreContext;
export default observer(withRouter(StaffAdd));
